import { AccountType } from "component-library";
import config from "config/global";
import { BillingUser } from "translations/src/models/billing";

export const SCROLLING_CONTAINER_ID = "body";

export const DEFAULT_LOCALE = "en-GB";

// ========================== Routes ==========================

export const BASE_PATH = "/myhome";

export const CHECKOUT_PATH = "checkout/:type";

export const CHECKOUT_COMPLETE_PATH = ":userType/complete";

export const CHECKOUT_FULL_PATH = `${BASE_PATH}/checkout/:type`;

export const CHECKOUT_COMPLETE_FULL_PATH = `${BASE_PATH}/checkout/:type/:userType/complete`;

export const ACCOUNT_SETTINGS_PATH = "account-settings";

export const MY_DETAILS_PATH = "my-details";

export const MY_LOGIN_DETAILS_PATH = "my-login-details";

export const MY_SUBSCRIPTION_PATH = "my-subscription";

export const ACCOUNT_SETTINGS_FULL_PATH = `${BASE_PATH}/${ACCOUNT_SETTINGS_PATH}`;

export const MY_DETAILS_FULL_PATH = `${BASE_PATH}/${ACCOUNT_SETTINGS_PATH}/${MY_DETAILS_PATH}`;

export const MY_LOGIN_DETAILS_FULL_PATH = `${BASE_PATH}/${ACCOUNT_SETTINGS_PATH}/${MY_LOGIN_DETAILS_PATH}`;

export const MY_SUBSCRIPTION_FULL_PATH = `${BASE_PATH}/${ACCOUNT_SETTINGS_PATH}/${MY_SUBSCRIPTION_PATH}`;

export const GRAD_TRANSFER_PATH = "graduate-transfer/information";

export const GRAD_TRANSFER_FULL_PATH = `${BASE_PATH}/${GRAD_TRANSFER_PATH}`;

// ========================== Routes ==========================

export enum CheckoutType {
  Renewal = "renewal",
  Reactivation = "reactivation",
  Graduate = "graduate",
  Change = "change-plan",
}

export enum ErrorCode {
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  UnprocessableEntity = 422,
  InternalServerError = 500,
}

export const ACCOUNT_TYPE_GTM_MAPPING = {
  [AccountType.Agent]: config.gtm.accountTypes.agent,
  [AccountType.Performer]: config.gtm.accountTypes.performer,
  [AccountType.CastingDirector]: config.gtm.accountTypes.castingDirector,
};

export enum ErrorPopupType {
  System = "systemError",
  Account = "accountError",
  Access = "accountAccessError",
  Network = "networkError",
}

export const AccountTypeBillingTypeMap = {
  castingDirector: BillingUser.Casting,
  "castingDirector:searchOnlyCastingDirector": BillingUser.Casting,
  performer: BillingUser.Performer,
  "performer:youngPerformer": BillingUser.YoungPerformer,
  "performer:graduate": BillingUser.Graduate,
  // Transferring grads are main perfs; handled in useGetUserType
};

export const SHOW_SUBSCRIPTION_CHANGE_SUCCESS_PARAM =
  "subscriptionChangeSuccess";
